import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { getResult } from './store/dataSlice'
import { injectReducer } from 'store'
import reducer from './store'
import ReconcileView from './components/ReconcileView'

injectReducer('pendingInvoices', reducer)

const View = () => {
    const { id } = useParams()
    const dispatch = useDispatch()
    const fetchData = (data) => dispatch(getResult(data))

    const { loading, result } = useSelector(
        (state) => state.pendingInvoices.data,
    )

    useEffect(() => {
        fetchData({ invoice_num: id })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id])

    if (loading)
        return (
            <div className="flex justify-center items-center text-2xl mt-[25%]">
                Loading...
            </div>
        )

    return (
        <ReconcileView
            data={result}
            invoiceData={
                result?.invoice_data
                    ? {
                          ...JSON.parse(result?.invoice_data[0]?.data),
                          services: JSON.parse(
                              result?.invoice_data[0]?.data,
                          ).services.flatMap((service) =>
                              service.line_items.map((lineitem) => ({
                                  ...lineitem,
                                  service: service.name,
                              })),
                          ),
                      }
                    : {}
            }
            reconciledData={
                result?.reconciled_records
                    ? {
                          ...(typeof result?.reconciled_records?.invoice
                              ?.reconciled_invoice_data === 'string'
                              ? JSON.parse(
                                    result?.reconciled_records?.invoice
                                        ?.reconciled_invoice_data,
                                )
                              : result?.reconciled_records?.invoice
                                    ?.reconciled_invoice_data),
                          services: (typeof result?.reconciled_records?.invoice
                              ?.reconciled_invoice_data === 'string'
                              ? JSON.parse(
                                    result?.reconciled_records?.invoice
                                        ?.reconciled_invoice_data,
                                )
                              : result?.reconciled_records?.invoice
                                    ?.reconciled_invoice_data
                          )?.service_data.flatMap((item) =>
                              item.line_items.map((lineitem) => ({
                                  ...lineitem,
                                  service: item.service_name,
                              })),
                          ),
                          total_overcharged:
                              result?.reconciled_records?.invoice
                                  ?.total_overcharged,
                          total_undercharged:
                              result?.reconciled_records?.invoice
                                  ?.total_undercharged,
                      }
                    : {}
            }
            versionOptions={
                result?.version_numbers
                    ? result?.version_numbers?.map((item) => ({
                          label: `Version-${item}`,
                          value: item,
                      }))
                    : []
            }
            version={result?.reconciled_records?.version_no}
            fetchData={(version) =>
                fetchData({ invoice_num: id, version: version })
            }
        />
    )
}

export default View
